module.exports = __webpack_public_path__ + "img/LIENVIETPOSTBANK.be628b8b.svg";